import Vue from 'vue'

import {
  getMatchedComponentsInstances,
  promisify,
  globalHandleError
} from './utils'

import NuxtError from '../layouts/error.vue'
import NuxtLoading from './components/nuxt-loading.vue'

import '../assets/css/index.less'

import _77180f1e from '../layouts/blank.vue'
import _6f6c098b from '../layouts/default.vue'

const layouts = { "_blank": _77180f1e,"_default": _6f6c098b }

export default {
  head: {"htmlAttrs":{"lang":"zh-Hans"},"title":"高途素养","meta":[{"charset":"utf-8"},{"name":"renderer","content":"webkit"},{"name":"force-rendering","content":"webkit"},{"http-equiv":"X-UA-Compatible","content":"IE=Edge,chrome=1"},{"name":"viewport","content":"width=device-width, initial-scale=1, maximum-scale=1, user-scalable=0"},{"hid":"keywords","name":"keywords","content":"高途,高途课堂,职业教育,成人教育,编制考试,在线学习,高途财经,高途考研,高途公职,高途教师,考研,公考,财会,初会中级会计师,英语,司考,大数据,公务员,教师资格证,粉笔,中公教育,橙啦,考虫,中华会计网校,大学慕课,学而思,新东方,网易云课堂,腾讯云课堂,尚德,考研帮,华图在线,高顿网校"},{"hid":"description","name":"description","content":"高途是一家科技教育公司，提供涵盖中小学生素质教育培训、大学教育培训、成人教育培训、职业教育培训和智能学习服务等。"}],"link":[{"rel":"shortcut icon","href":"\u002Ffavicon.ico"},{"rel":"dns-prefetch","href":"\u002F\u002Fcstaticdun.126.net"},{"rel":"dns-prefetch","href":"\u002F\u002Flib.gsxcdn.com"},{"rel":"dns-prefetch","href":"\u002F\u002Fwebchat.7moor.com"},{"rel":"dns-prefetch","href":"\u002F\u002Fgtoss.gsxcdn.com"},{"rel":"dns-prefetch","href":"\u002F\u002Fei.cnzz.com"},{"rel":"dns-prefetch","href":"\u002F\u002Fimg.gsxservice.com"},{"rel":"dns-prefetch","href":"\u002F\u002Fi.gsxcdn.com"},{"rel":"dns-prefetch","href":"\u002F\u002Fs22.cnzz.com"},{"rel":"dns-prefetch","href":"\u002F\u002Fc.cnzz.com"}],"script":[{"innerHTML":"var _czc = _czc || [];\n                _czc.push(['_setAccount', '1271279500']);\n                ","body":true},{"innerHTML":"\n                var _hmt = _hmt || [];\n                (function () {\n                var hm = document.createElement(\"script\");\n                hm.src = \"https:\u002F\u002Fhm.baidu.com\u002Fhm.js?dadae47249adca4331765be384110450\";\n                var s = document.getElementsByTagName(\"script\")[0];\n                s.parentNode.insertBefore(hm, s);\n                })();\n                ","body":true},{"src":"\u002F\u002Fcstaticdun.126.net\u002Fload.min.js","type":"text\u002Fjavascript","charset":"utf-8","async":"async","body":true},{"src":"\u002F\u002Fstatic.tongdun.net\u002Fmonitor\u002Fmonitor.js","type":"text\u002Fjavascript","charset":"utf-8","async":"async","body":true,"crossorigin":"anonymous"},{"innerHTML":"\n        window._fmOpt = {\n            partner: 'gaotu',\n            appName: 'gaotu_web',\n            token: 'gaotu' + '-' + new Date().getTime() + '-' + Math.random().toString(16).substr(2),\n            fmb: true,\n            success(data) {\n                window.blackbox = data;\n                \u002F\u002F 在成功完成采集后，success 回调中可以获取到 blackbox，在获取到 blackbox 后传 输过程中请进行 url 编码\n                \u002F\u002F console.log('blackbox: ', data);\n            },\n            fpHost: 'https:\u002F\u002Ffp.tongdun.net'\n        };\n\n        var cimg = new Image(1,1);\n        cimg.onload = function() {\n            _fmOpt.imgLoaded = true;\n        };\n        cimg.src = 'https:\u002F\u002Ffp.tongdun.net\u002Ffp\u002Fclear.png?partnerCode=erzcn&appName=erzcn_web&tokenId=' + _fmOpt.token;\n        var fm = document.createElement('script');\n        fm.type = 'text\u002Fjavascript';\n        fm.async = true;\n        fm.src = ('https:' == document.location.protocol ? 'https:\u002F\u002F' : 'http:\u002F\u002F') + 'static.tongdun.net\u002Fv3\u002Ffm.js?ver=0.1&t=' + (new Date().getTime()\u002F3600000).toFixed(0);\n        var s = document.getElementsByTagName('script')[0];\n        s.parentNode.insertBefore(fm, s);\n    ","body":true},{"src":"\u002F\u002Fg.alicdn.com\u002FAWSC\u002FAWSC\u002Fawsc.js","type":"text\u002Fjavascript"},{"innerHTML":"\n        var uabModule;\n        var webUmidToken;\n\n        \u002F\u002F人机识别模块，只需初始化一次\n        AWSC.use(\"uab\", function (state, uab) {\n            if(state === \"loaded\") {\n                uabModule = uab;\n            }\n        });\n        \u002F\u002F设备指纹模块，得到设备token，只需初始化一次\n        AWSC.use(\"um\", function (state, um) {\n            if(state === \"loaded\") {\n                um.init({\n                    appName: 'saf-aliyun-com',\n                }, function (initState, result) {\n                    if(initState === 'success') {\n                        webUmidToken = result.tn;\n                    }\n                });\n            }\n        });\n    ","body":true},{"innerHTML":"\n        !function (e, t, n, g, i) {\n            e[i] = e[i] || function () {\n                (e[i].q = e[i].q || []).push(arguments)\n            }, n = t.createElement(\"script\"), tag = t.getElementsByTagName(\"script\")[0], n.async = 1, n.src = ('https:' == document.location.protocol ? 'https:\u002F\u002F' : 'http:\u002F\u002F') + g, tag.parentNode.insertBefore(n, tag)\n        }(window, document, \"script\", \"assets.giocdn.com\u002F2.1\u002Fgio.js\", \"gio\");\n        gio('init', 'be26a9c1d6166354', {});\n        gio('send');\n    ","data-cy":"gio"}],"__dangerouslyDisableSanitizers":["script"],"style":[]},

  render (h, props) {
    const loadingEl = h('NuxtLoading', { ref: 'loading' })

    if (this.nuxt.err && NuxtError) {
      const errorLayout = (NuxtError.options || NuxtError).layout
      if (errorLayout) {
        this.setLayout(
          typeof errorLayout === 'function'
            ? errorLayout.call(NuxtError, this.context)
            : errorLayout
        )
      }
    }

    const layoutEl = h(this.layout || 'nuxt')
    const templateEl = h('div', {
      domProps: {
        id: '__layout'
      },
      key: this.layoutName
    }, [layoutEl])

    const transitionEl = h('transition', {
      props: {
        name: 'layout',
        mode: 'out-in'
      },
      on: {
        beforeEnter (el) {
          // Ensure to trigger scroll event after calling scrollBehavior
          window.$nuxt.$nextTick(() => {
            window.$nuxt.$emit('triggerScroll')
          })
        }
      }
    }, [templateEl])

    return h('div', {
      domProps: {
        id: '__nuxt'
      }
    }, [
      loadingEl,

      transitionEl
    ])
  },

  data: () => ({
    isOnline: true,

    layout: null,
    layoutName: ''
  }),

  beforeCreate () {
    Vue.util.defineReactive(this, 'nuxt', this.$options.nuxt)
  },
  created () {
    // Add this.$nuxt in child instances
    Vue.prototype.$nuxt = this
    // add to window so we can listen when ready
    if (process.client) {
      window.$nuxt = this

      this.refreshOnlineStatus()
      // Setup the listeners
      window.addEventListener('online', this.refreshOnlineStatus)
      window.addEventListener('offline', this.refreshOnlineStatus)
    }
    // Add $nuxt.error()
    this.error = this.nuxt.error
    // Add $nuxt.context
    this.context = this.$options.context
  },

  mounted () {
    this.$loading = this.$refs.loading
  },
  watch: {
    'nuxt.err': 'errorChanged'
  },

  computed: {
    isOffline () {
      return !this.isOnline
    }
  },

  methods: {
    refreshOnlineStatus () {
      if (process.client) {
        if (typeof window.navigator.onLine === 'undefined') {
          // If the browser doesn't support connection status reports
          // assume that we are online because most apps' only react
          // when they now that the connection has been interrupted
          this.isOnline = true
        } else {
          this.isOnline = window.navigator.onLine
        }
      }
    },

    async refresh () {
      const pages = getMatchedComponentsInstances(this.$route)

      if (!pages.length) {
        return
      }
      this.$loading.start()

      const promises = pages.map((page) => {
        const p = []

        if (page.$options.fetch) {
          p.push(promisify(page.$options.fetch, this.context))
        }

        if (page.$options.asyncData) {
          p.push(
            promisify(page.$options.asyncData, this.context)
              .then((newData) => {
                for (const key in newData) {
                  Vue.set(page.$data, key, newData[key])
                }
              })
          )
        }

        return Promise.all(p)
      })
      try {
        await Promise.all(promises)
      } catch (error) {
        this.$loading.fail()
        globalHandleError(error)
        this.error(error)
      }
      this.$loading.finish()
    },

    errorChanged () {
      if (this.nuxt.err && this.$loading) {
        if (this.$loading.fail) {
          this.$loading.fail()
        }
        if (this.$loading.finish) {
          this.$loading.finish()
        }
      }
    },

    setLayout (layout) {
      if (!layout || !layouts['_' + layout]) {
        layout = 'default'
      }
      this.layoutName = layout
      this.layout = layouts['_' + layout]
      return this.layout
    },
    loadLayout (layout) {
      if (!layout || !layouts['_' + layout]) {
        layout = 'default'
      }
      return Promise.resolve(layouts['_' + layout])
    }
  },

  components: {
    NuxtLoading
  }
}
